module.exports = __webpack_public_path__ + "static/media/mode-pdb-logo-ripeurs-orange.6a9971fa.png";